import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';

import { libraryShape, subscriptionShape } from '@bibliocommons/bc-prop-types';

import { trackRequestExternalPlace } from 'app/actions/AnalyticsGa4Actions';
import BibsActions from 'app/actions/BibsActions';
import {
  selectAvailabilityError,
  selectBibItemsForCurrentBib,
  selectProbesForCurrentBib,
  selectSubscriptionsForCurrentBib
} from 'app/selectors/bibs/AvailabilitySelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import AvailabilityDetails from './AvailabilityDetails';

export function AvailabilityDetailsContainer(props) {
  const { fetchAvailability, metadataId } = props;

  useEffect(() => {
    fetchAvailability(metadataId);
  }, [fetchAvailability, metadataId]);

  return <AvailabilityDetails {...props} />;
}

AvailabilityDetailsContainer.propTypes = {
  availabilityError: PropTypes.string,
  bibItems: ImmutablePropTypes.list.isRequired,
  currentLibrary: libraryShape.isRequired,
  fetchAvailability: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  metadataId: PropTypes.string.isRequired,
  probes: ImmutablePropTypes.list.isRequired,
  subscriptions: ImmutablePropTypes.listOf(subscriptionShape).isRequired
};

const mapStateToProps = state => ({
  availabilityError: selectAvailabilityError(state),
  currentView: state.getIn(['search', 'catalogSearch', 'view']),
  currentLibrary: selectCurrentLibrary(state),
  bibItems: selectBibItemsForCurrentBib(state),
  isFetching: state.getIn(['bibs', 'availability', 'isFetching'], false),
  pagination: state.getIn(['search', 'catalogSearch', 'pagination']),
  probes: selectProbesForCurrentBib(state),
  sortBys: state.getIn(['search', 'catalogSearch', 'sortBys']),
  subscriptions: selectSubscriptionsForCurrentBib(state)
});

const mapDispatchToProps = {
  fetchAvailability: BibsActions.fetchAvailability,
  trackRequestExternalPlace
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailabilityDetailsContainer);
